import { render, staticRenderFns } from "./TariffDetail.vue?vue&type=template&id=bf6279c6&scoped=true"
import script from "./TariffDetail.vue?vue&type=script&lang=js"
export * from "./TariffDetail.vue?vue&type=script&lang=js"


/* normalize component */
import normalizer from "!../../../../../node_modules/@vue/vue-loader-v15/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "bf6279c6",
  null
  
)

export default component.exports